import { gql } from '@lichtblick/apollo';

export const GET_SINGLE_ORDER = gql`
  query getSingleWorkOrder($input: GetWorkOrderInput!) {
    getWorkOrder_V1(input: $input) {
      error
      data {
        eaasId
        id
        name
        branchOffice {
          id
          name
        }
        projectManager {
          id
          eMail
          firstName
          lastName
        }
      }
    }
  }
`;
